module.exports = __webpack_public_path__ + "static/media/FR.e40b5c33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/FR.svg
// module id = 254
// module chunks = 0